// @ts-nocheck

import { Data, ResponseCubeSpecialDataEntry } from 'types/api/Tenant/AROCube/CubeDataEntryTypes';
interface InputData {
  id: string;
  attribute: string;
  Value: number;
  rowid: string;
  path: string[];
}

interface OutputDataSpecialEntry {
  attributeId: string;
  value: number;
  member: string;
  xMember: string;
}

export const jsonToGridDataSpecialEntry = (json?: ResponseCubeSpecialDataEntry) => {
  if (!json) return [];
  const rows = [];
  json.attributes.forEach((attr) => {
    const rowData = {
      id: attr.id,
      attribute: attr.displayName,
      path: [attr.displayName],
      rowid: `${attr.name}#Value#${attr.id}`,
    };
    Object.entries(json.data).forEach(([key, specialData]) => {
      const specialDataValue = specialData.find((v) => v.name === attr.name);

      rowData[key] = specialDataValue.value;
    });
    rows.push(rowData);
  });
  return rows;
};

export const jsonToGridData = (
  json?: {
    attributes: CubeDataEntryAttribute[];
    data: Data;
  },
  withCustomSorting: boolean
) => {
  if (!json) return [];
  // @ts-ignore
  const rows = [];
  const attributeMap = new Map(json.attributes.map((attr) => [attr.id, attr]));

  json.attributes.forEach((attr) => {
    const rowData = {
      id: attr.id,
      attribute: attr.displayName,
    };
    Object.entries(json.data).forEach(([key, value]) => {
      // @ts-ignore
      rowData[key] = value[attr.name];
      // @ts-ignore
      rowData['rowid'] = `${attr.name}#${key}#${value.id}`;
      // @ts-ignore
      rowData['path'] = generateTreeDataPath(attr, attributeMap);
    });
    rows.push(rowData);
  });

  if (!withCustomSorting) return rows;

  // sorting the rows array based on the path
  return rows.sort((a, b) => {
    let i = 0;
    while (true) {
      if (!a.path[i] && !b.path[i]) {
        return 0;
      }
      if (!a.path[i]) {
        return -1;
      }
      if (!b.path[i]) {
        return 1;
      }
      const comparison = a.path[i].localeCompare(b.path[i]);
      if (comparison !== 0) {
        return comparison;
      }
      i++;
    }
  });
};

function generateTreeDataPath(attribute, attributeMap) {
  const path = [attribute.displayName];
  let currentAttribute = attribute;

  while (currentAttribute.parent) {
    const parent = attributeMap.get(currentAttribute.parent);
    if (!parent) break;
    path.unshift(parent.displayName);
    currentAttribute = parent;
  }

  return path;
}
const META_KEYS = new Set(['id', 'attribute', 'path', 'rowid']);

export function getChangedMemberKeys(inputData: InputData[], initialData: InputData[]): Set<string> {
  const changed = new Set<string>();
  const initialByRowId = new Map(initialData.map((r) => [r.rowid, r]));

  inputData.forEach((item) => {
    const original = initialByRowId.get(item.rowid);

    // New row ➜ every member key in it is “changed”
    if (!original) {
      Object.keys(item)
        .filter((k) => !META_KEYS.has(k))
        .forEach((k) => changed.add(k));
      return;
    }

    // Compare cell-by-cell
    Object.entries(item).forEach(([key, value]) => {
      if (META_KEYS.has(key)) return;
      if (original[key as keyof typeof original] !== value) {
        changed.add(key);
      }
    });
  });

  return changed;
}

export function transformDataSpecialEntry(
  inputData: InputData[],
  initialData: InputData[],
  refrenceData: ResponseCubeSpecialDataEntry
): OutputDataSpecialEntry[] {
  const result: OutputDataSpecialEntry[] = [];
  const changedRowIds = getChangedMemberKeys(inputData, initialData);

  inputData.forEach((item) => {
    // rowid looks like   metricSlug#member#uuid[#xMember?]
    const [attributeName] = (item.rowid ?? '').split('#');

    Object.entries(item).forEach(([key, raw]) => {
      // ignore the non-measure fields
      if (['id', 'attribute', 'path', 'rowid'].includes(key)) return;

      const value = raw || 0;

      if (changedRowIds.has(key)) {
        const recordId = refrenceData.data?.[key]?.find((v) => v.name === attributeName)?.id;
        result.push({
          attributeId: item.id,
          id: recordId, // uuid from rowid
          value, // the actual metric number
          member: key, // the truck / member column
          // xMember: xMember ?? null, // fourth part, if ever present
        });
      }
    });
  });

  return result;
}

export function transformData(rawData, initialReferenceData) {
  const result = {};

  rawData.forEach((item) => {
    const attributeKey = item.rowid.split('#')[0];
    for (const key in item) {
      const pattern = /^(\d{2}-\d{2}-\d{2}|[A-Z][a-z]{2}-\d{2}|[A-Z][a-z]{2}-[A-Z][a-z]{2} \d{4}|FY-\d{4}\/\d{2})$/;
      if (key.match(pattern)) {
        if (!result[key]) {
          result[key] = {
            id: initialReferenceData[key] ? initialReferenceData[key].id : null,
          };
        }
        if (result[key]) {
          result[key][attributeKey] = item[key];
        }
      }
    }
  });

  return result;
}
function isCellValueChanged(rowId, field, rowData, initialData) {
  const initialRow = initialData.find((row) => row.rowid === rowId);
  if (!initialRow) return false;
  return rowData[field] !== initialRow[field];
}

export function getCellClassName(params, initialData) {
  const { row, field } = params;
  let className = '';

  if (isCellValueChanged(row.rowid, field, row, initialData)) {
    className += ' cube-entry-cell-changed';
  }

  return className;
}
